import { render, staticRenderFns } from "./pages.vue?vue&type=template&id=7b886216&"
import script from "./pages.vue?vue&type=script&lang=js&"
export * from "./pages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports